import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakType,
} from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import PlannedBreakForm from './forms/PlannedBreakForm'

const onAddPlannedBreak = (
  breakConfiguration: BreakConfigurationFragment,
  breakType: BreakType,
  plannedBreakForms: PlannedBreakForm[],
  onSuccess: (forms: PlannedBreakForm[]) => void
) => {
  const { name, id, paid } = breakConfiguration
  const newBreakForm = new PlannedBreakForm({
    'break_configuration.id': id,
    'break_configuration.name': name,
    'break_configuration.paid': paid,
    break_type: breakType,
  })
  track(trackingEvents.shiftManagement.addBreakSubmit, {
    id,
    type: paid ? 'paid' : 'unpaid',
    scheduling_type: breakType,
    from: 'custom-shifts',
  })
  onSuccess([...plannedBreakForms, newBreakForm])
}

const onDeletePlannedBreak = (
  breakForm: PlannedBreakForm,
  plannedBreakForms: PlannedBreakForm[],
  onSuccess: (forms: PlannedBreakForm[]) => void
) => {
  const updatedForms = plannedBreakForms.filter((form) => form !== breakForm)
  onSuccess(updatedForms)
}

export { onAddPlannedBreak, onDeletePlannedBreak }
